import { fetchInventorySnapshot } from "@/lib/inventorySnapshot.js";
import { countCollectionTokens } from "@/lib/collectionBalance.js";
import { $apiV5 } from "@plugins/axios";

const NFT_API = {
  equipPilot: "/nfts/equip-mystic",
  equipMech: "/nfts/equip-second-mystic",
  equipOrb: "/nfts/equip-third-mystic",
  unequipPilot: "/nfts/unequip-mystic",
  unequipMech: "/nfts/unequip-second-mystic",
  unequipOrb: "/nfts/unequip-third-mystic",
};

const postNftRequest = async (url, payload) => {
  try {
    const { data } = await $apiV5.post(url, payload);
    return data;
  } catch (error) {
    console.error(`NFT request failed for ${url}:`, error);
    throw error;
  }
};

export const equipPilotNft = (payload) =>
  postNftRequest(NFT_API.equipPilot, payload);

export const equipMechNft = (payload) =>
  postNftRequest(NFT_API.equipMech, payload);

export const equipOrbNft = (payload) =>
  postNftRequest(NFT_API.equipOrb, payload);

export const unequipPilotNft = (payload) =>
  postNftRequest(NFT_API.unequipPilot, payload);

export const unequipMechNft = (payload) =>
  postNftRequest(NFT_API.unequipMech, payload);

export const unequipOrbNft = (payload) =>
  postNftRequest(NFT_API.unequipOrb, payload);

export async function getSparkleBalance(walletAddress) {
  if (!walletAddress) throw new Error("Connect your wallet to load Sparkles");
  const items = await fetchInventorySnapshot($apiV5.get.bind($apiV5), {
    chain: "avalanche", forceRefresh: true,
  });
  return countCollectionTokens(items, {
    chain: "avalanche", contract: import.meta.env.VITE_CONTRACT_SPARKLE,
    wallet: walletAddress,
  });
}
